import { useState } from "react";
import { PiEyeClosedLight } from "react-icons/pi";
import { BsEye } from "react-icons/bs";

const CustomInput = ({
    className,
    placeholder,
    label,
    name,
    value,
    onChange,
    error,
    type = "text",
    onBlur,
    mandatory,
    required,
    max,
    pattern,
    title
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePassword = () => setShowPassword((prev) => !prev);
    const isPassword = type === "password";

    return (
        <div className="mb-3">
            <label className="block text-sm font-medium text-gray-600 mb-1">
                {label}
                <sup className="text-red-500 text-sm">{mandatory ? "*" : ""}</sup>
            </label>

            <div className="relative">
                <input
                    type={isPassword && showPassword ? "text" : type}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    pattern={pattern}
                    onBlur={onBlur}
                    required={required}
                    title={title}
                    max={max}
                    className={`border rounded-md px-3 py-3 text-sm mt-1 focus:outline-none focus:ring-2 ${error ? "border-red-500" : "border-gray-300"
                        } ${className}`}
                />

                {isPassword && (
                    <button
                        type="button"
                        onClick={togglePassword}
                        className="absolute inset-y-0 right-3 flex items-center"
                    >
                        {showPassword ? <BsEye size={20} /> : <PiEyeClosedLight size={20} />}
                    </button>
                )}
            </div>

            {error && (
                <div className="bg-red-100 rounded-md h-auto">
                    <p className="text-red-500 text-sm mt-1 ml-3">{error}</p>
                </div>
            )}
        </div>
    );
};

export default CustomInput;
